import { render, staticRenderFns } from "./Jurisdiction.vue?vue&type=template&id=041cdcac&scoped=true&"
import script from "./Jurisdiction.vue?vue&type=script&lang=js&"
export * from "./Jurisdiction.vue?vue&type=script&lang=js&"
import style0 from "./Jurisdiction.vue?vue&type=style&index=0&id=041cdcac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041cdcac",
  null
  
)

export default component.exports